'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import ProjectInvestorCountryDirective from './directive/projectInvestorCountry';

export default angular.module('investmentProject.project.investorCountry', [])
    .directive('projectInvestorCountry', ProjectInvestorCountryDirective)
    .name;
